import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/Login',
			name: 'Login',
			meta: { layout: 'Default' },
			component: () => import('@/components/Login')
		},
		{
			path: '/Registro',
			name: 'Registro',
			meta: { layout: 'Content' },
			component: () => import('@/components/Registro')
		},
		{
			path: '/RolesPermisos',
			name: 'RolesPermisos',
			meta: { layout: 'Content' },
			component: () => import('@/components/RolesPermisos')
		},
		{
			path: '/EjecutivoEmpresa',
			name: 'EjecutivoEmpresa',
			meta: { layout: 'Content' },
			component: () => import('@/components/EjecutivoEmpresa')
		},
		{
			path: '/AgenteEjecutivo',
			name: 'AgenteEjecutivo',
			meta: { layout: 'Content' },
			component: () => import('@/components/AgenteEjecutivo')
		},
		{
			path: '/Home',
			name: 'Home',
			meta: { layout: 'Content' },
			component: () => import('@/components/MonitorCuotas')
		},
		{
			path: '/ResumenNegocio',
			name: 'ResumenNegocio',
			meta: { layout: 'Content' },
			component: () => import('@/components/ResumenNegocios')
		},
		{
			path: '/IngresoNegocio',
			name: 'IngresoNegocio',
			meta: { layout: 'Content' },
			component: () => import('@/components/IngresoNegocios')
		},
		{
			path: '/IngresoClientes',
			name: 'IngresoClientes',
			meta: { layout: 'Content' },
			component: () => import('@/components/IngresoClientes')
		},
		{
			path: '/LinkNegocio',
			name: 'LinkNegocio',
			meta: { layout: 'Content' },
			component: () => import('@/components/LinkNegocio')
		},
		{
			path: '/GestionCuota',
			name: 'GestionCuota',
			meta: { layout: 'Content' },
			params: { credito: null, cuota: null, dni: null },
			component: () => import('@/components/GestionCuota')
		},
		{
			path: '/PrintNegocio',
			name: 'PrintNegocio',
			meta: { layout: 'Print' },
			component: () => import('@/components/PrintNegocio')
		},
		{
			path: '/InformeNegociosExcel',
			name: 'InformeNegociosExcel',
			meta: { layout: 'Content' },
			component: () => import('@/components/InformeNegociosExcel')
		},
		{
			path: '*',
			redirect: '/Login'
		},
		{
			path: '/Clientes',
			name: 'Clientes',
			meta: { layout: 'Content' },
			component: () => import('@/components/Clientes')
		}
	]
})

router.beforeEach((to, from, next) => {
	store.dispatch('fetchAccessToken')
	if (store.state.accessToken) {
		store.dispatch('fetchAccessMenu')
	}
	if (to.fullPath === '/Home') {
		if (!store.state.accessToken) {
			next('/Login')
		}
	}
	if (to.fullPath === '/Login') {
		if (store.state.accessToken) {
			next('/Home')
		}
	}
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js